<template>
  <span class="library-badge" :class="badgeClass">
    <component :is="icon" v-if="icon" />
    {{ name }}
  </span>
</template>

<script>

export default {
  props: {
    name: { type: String, default: '', required: true },
  },
  data() {
    return {
      icons: ['beginner', 'intermediate', 'advanced'],
    };
  },
  computed: {
    badgeClass() {
      // eslint-disable-next-line no-useless-escape
      return this.name.replace('/\s/g ', '-').toLowerCase();
    },
    icon() {
      if (this.icons.includes(this.badgeClass)) {
        // eslint-disable-next-line import/no-dynamic-require
        return require(`../assets/svg/icon-library-badge-${this.badgeClass}.svg?vue-component`);
      }

      return false;
    },
  },
};
</script>

<style lang="scss">
.library-badge {
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  padding: 3px 12px;
  border-radius: 100px;
  background-color: var(--main-dark);
  border: 2px solid var(--main-dark-shade-3);
  display: inline-flex;
  align-items: center;
  text-transform: capitalize;

  svg {
    margin-right: 4px;
  }

  &.free {
    color: var(--accent-light-3);
  }

  &.beginner {
    color: var(--main-green-light-3);
  }

  &.intermediate {
    color: var(--main-yellow);
  }

  &.advanced {
    color: var(--main-red);
  }
}
</style>
